import { useQuery } from "@tanstack/react-query";
import { useCurrentTenant } from "app/jm";
import { getDownloadURL, getStorage, ref } from "firebase/storage";

export const useFirebaseTenantDownloadURL = (path: string) => {
  const { firebaseTenantId } = useCurrentTenant();
  const absolutePath = `tenants/${firebaseTenantId}/${path}`;

  return useQuery({
    queryKey: ["downloadURL", absolutePath],
    queryFn: async () => {
      const storage = getStorage();
      const fileRef = ref(storage, absolutePath);
      return await getDownloadURL(fileRef);
    },
    enabled: !!firebaseTenantId,
  });
};
